import { usePeriodDates } from 'src/compass/shared/hooks/usePeriodDates';
import { findNearestAsofDate } from '../utils/findNearestAsofDate';

function defaultAsOfValues(row: any, currentPeriodStart: any) {
  const { asOfs, ...restOfRow } = row;
  const dateList = asOfs.map((asOf:any) => asOf.asOfDate)
  const nearestAsofDate = findNearestAsofDate(dateList, currentPeriodStart)

  return {
    ...restOfRow,
    ...(asOfs?.length > 0 && { asOf: asOfs.find((asOf:any) => asOf.asOfDate === nearestAsofDate)})
  };
}

export default function useDefaultAsOfValues(
  row: any = {},
  defaultFormValues: Record<string, any> = {}
) {
  const { id } = row;

  const { data } = usePeriodDates();
  const { currentPeriodStart } = data;

  return id ? defaultAsOfValues(row, currentPeriodStart) : defaultFormValues
}
